import React from 'react';

/** 연간시간표 교시 헤더 — 모바일 Safari에서도 안정적인 세로 글자(1 → 교 → 시) */
export const AnnualPeriodHeadLabel: React.FC<{ label: string }> = ({ label }) => {
  const trimmed = label.trim();
  if (!trimmed) return null;
  return (
    <span className="cp-annual-period-head-th-label" aria-hidden="true">
      {Array.from(trimmed).map((ch, i) => (
        <span key={`${i}-${ch}`} className="cp-annual-period-head-th-char">
          {ch}
        </span>
      ))}
    </span>
  );
};
